/**
 * Metni arama karşılaştırması için katlar; terime de aranan alana da aynı biçimde uygulanır.
 * `'İ'.toLowerCase()` i + U+0307 verir, `tr` yereli de ISO'yu ıso yapar: bu yüzden işaretler
 * NFD'de atılır (ş/ğ/ç/ö/ü ASCII karşılığına düşer) ve ı da i'ye indirilir.
 */
export function foldForSearch(text) {
    return text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\u0131/g, 'i')
        .replace(/\s+/g, ' ')
        .trim();
}
//# sourceMappingURL=search-text.js.map